module.exports = __webpack_public_path__ + "static/media/home.adaebdc3.png";